// extracted by mini-css-extract-plugin
module.exports = {"loading-content":"LoadingWithInfo_loading-content__1o-xZ","title-loading":"LoadingWithInfo_title-loading__3WCMn","sub-title":"LoadingWithInfo_sub-title__3xuak"};